<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="5vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span
        class="title-text">{{ factoryName + $t('factoryLabelPrint.templateContentEditing') }}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="P/N:" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.lotNo') + ':'" prop="lotNo">
            <el-input
              v-model.trim="form.lotNo"
              name="lotNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.waferCount') + ':'" prop="waferCount">
            <el-input
              v-model.trim.number="form.waferCount"
              name="waferCount"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Tracking No:" prop="trackingNo">
            <el-input
              v-model.trim="form.trackingNo"
              name="trackingNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.storageDate') + ':'" prop="dateCode">
            <el-date-picker
              v-model="form.dateCode"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.count') + ':'" prop="qty">
            <el-input
              v-model.trim.number="form.qty"
              name="qty"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.binLevel') + ':'" prop="binLevel">
            <el-input
              v-model.trim="form.binLevel"
              name="binLevel"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            :id="labelName"
            scrolling="no"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
          <el-button style="position: absolute; margin-left: 10px;" size="small" @click="printWaferBoxLabelFrame">{{$t('common.print')}}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{ $t('common.sure') }}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import moment from 'moment';
import {
  validateCount,
  validateLotNo, validateWaferCount
} from '@/utils/validate';
import {
  initWaferBoxLabelFrame,
  printFactoryLabel,
} from '@/utils/factory-label';
import {
  updateBox,
} from '@/api/boxLabel';
import {
  updateLabel,
} from '@/api/label';

export default {
  name: "WaferLabelDialog",
  props: {
    factoryName: {
      type: String,
      default: '',
    },
    labelName: {
      type: String,
      default: 'historyLabelIFrameWaferBoxLabelDialog',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    editRow: {
      type: Object,
      default: () => {},
    },
    isBoxLabel: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      form: {
        partNo: undefined,
        lotNo: undefined,
        waferCount: undefined,
        dateCode: undefined,
        qty: undefined,
        trackingNo: undefined,
        binLevel: undefined,
      },
      rules: {
        partNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.partNoCanNotBeEmpty')
        }],
        lotNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('validate.lotNoCanNotBeEmpty')
        }],
        waferCount: [{
          required: true,
          trigger: 'blur',
          validator: validateWaferCount
        }],
        dateCode: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.storageDateCanNotBeEmpty')
        }],
        qty: [{
          required: true,
          trigger: 'blur',
          validator: validateCount
        }],
        trackingNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('validate.trackingNoCanNotBeEmpty'),
        }],
      },
      loading: false,
    }
  },
  watch: {
    editRow(newValue) {
      if (newValue && Object.keys(newValue).length > 0 && this.visible === true) {
        const {
          id,
          partNo,
          lotNo,
          qty,
          trackingNo,
          dateCode,
          reserve,
          packageType,
        } = newValue;
        this.form = {
          id,
          partNo,
          lotNo,
          waferCount: qty,
          dateCode: dateCode,
          qty: reserve,
          trackingNo: trackingNo,
          binLevel: packageType,
        };
        setTimeout(() => {
          this.initWaferBoxLabelFrame();
        }, 500);
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
      if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
        this.$refs.refForm.clearValidate();
      }
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          if (this.isBoxLabel) {
            this.updateBox();
          } else {
            this.updateLabel();
          }
        }
      });
    },
    initWaferBoxLabelFrame() {
      const {
        partNo,
        lotNo,
        waferCount,
        dateCode,
        qty,
        trackingNo,
        binLevel,
      } = this.form;
      let iframe = document.getElementById(this.labelName);
      iframe = initWaferBoxLabelFrame({
        iframe,
        partNo,
        lotNo,
        waferCount,
        dateCode,
        qty,
        trackingNo,
        binLevelExplain: binLevel || ''
      });
      iframe.contentWindow.document.close();
    },
    async updateBox() {
      const {
        id,
        partNo,
        lotNo,
        waferCount,
        dateCode,
        qty,
        trackingNo,
        binLevel,
      } = this.form;
      this.loading = true;
      try {
        await updateBox({
          boxLabelId: id,
          partNo,
          lotNo,
          qty: waferCount,
          trackingNo,
          dateCode: moment(dateCode).format('YYYY-MM-DD'),
          reserve: qty,
          packageType: binLevel || ''
        });
        this.$emit('update');
        this.close();
        this.$message({
          type: 'success',
          message: this.$t('common.updateSuccess'),
        });
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async updateLabel() {
      const {
        id,
        partNo,
        lotNo,
        waferCount,
        dateCode,
        qty,
        trackingNo,
        binLevel,
      } = this.form;
      this.loading = true;
      try {
        await updateLabel({
          labelId: id,
          partNo, 
          lotNo, 
          qty: waferCount,
          trackingNo,
          customPartNo: waferNo,
          marking: prop,
          dateCode: moment(dateCode).format('YYYY-MM-DD'),
          reserve: qty,
          packageType: binLevel || ''
        });
        this.$emit('update');
        this.close();
        this.$message({
          type: 'success',
          message: this.$t('common.updateSuccess'),
        });
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    printWaferBoxLabelFrame() {
      let iframe = document.getElementById(this.labelName);
      printFactoryLabel(iframe);
    },
  }
}
</script>

<style scoped>
.title-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
  padding: 10px 15px;
  align-items: center;
}

.title-text {
  color: #404040;
  font-size: 16px;
}

.el-form {
  margin: 0 30px;
}

.close-image {
  width: 22px;
  height: 22px;
  cursor: pointer;
  padding: 0 10px;
}
</style>
<style>
.edit-detail-dialog .el-dialog__header {
  padding: 0;
}
</style>

